export const getSelectedCompanyFilter = (prefix = null) => {
  let companyFilter = JSON.parse(localStorage.getItem('selectedCompany'));

  if (prefix) {
    companyFilter = Object.fromEntries(
      Object.entries(companyFilter).map(([key, value]) => [
        `${prefix}.${key}`,
        value,
      ])
    );
  }

  return companyFilter;
};

export const getSelectedCompanyFilterValue = () => {
  const selectedCompany = localStorage.getItem('selectedCompany');

  if (selectedCompany === null) {
    return '';
  }

  return JSON.parse(selectedCompany)['company'];
};
